var _style, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBch01 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0AC18E;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 250.5,
    cy: 250.5,
    r: 245.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "symbol_1_",
    className: "st1",
    d: "M327.1,168.1c-12.3-28-40.7-34-75.4-28.2l-11.2-43.2l-26.3,6.8l11,43.1 c-6.9,1.7-14,3.2-21.1,5.2l-11-42.9l-26.3,6.8L178,159c-5.7,1.6-53.1,13.8-53.1,13.8l7.2,28.2c0,0,19.3-5.4,19.1-5 c10.7-2.8,15.8,2.6,18.1,7.6L200.1,322c0.4,3.4-0.2,9.3-7.6,11.3c0.4,0.2-19.1,4.9-19.1,4.9l2.9,32.8c0,0,47-12,53.2-13.6l11.3,43.7 l26.3-6.8l-11.3-44.1c7.2-1.7,14.3-3.4,21.1-5.2L288,389l26.3-6.8L303,338.5c40.5-9.8,69.1-35.4,63.2-74.5 c-3.7-23.6-29.5-42.9-50.8-45C328.6,207.3,335.2,190.3,327.1,168.1L327.1,168.1z M314.4,271.2c5.2,38.7-48.5,43.4-66.3,48.1 l-15.5-57.9C250.5,256.7,305.6,237.1,314.4,271.2z M282,192.4c5.5,34.4-40.4,38.4-55.3,42.2L212.7,182 C227.6,178.3,270.8,160.5,282,192.4z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBch01);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/BCH-01.1aa3b814c5a6641349ec51c6e22532f5.svg";